"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContainer = void 0;
var react_dom_1 = __importDefault(require("react-dom"));
function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return container && react_dom_1.default.findDOMNode(container) || defaultContainer;
}
exports.getContainer = getContainer;